module.exports = __webpack_public_path__ + "static/media/LoyaltyWalletScreen.8e89bed7.png";